import { ClassType } from '@frontend/common';
import { StatusBadge } from '@frontend/components/common';
import { SpotStatus } from '@frontend/spot/types';
import React from 'react';

const SPOT_STATUS_COLOR_MAP = new Map<SpotStatus[], ClassType>([
    [[SpotStatus.AVAILABLE], ClassType.SUCCESS],
    [[SpotStatus.DISABLED], ClassType.DANGER]
]);

const formatSpotStatus = (status: SpotStatus): string => (status.charAt(0).toUpperCase() + status.slice(1)).replace(/_/g, ' ');

export interface SpotStatusBadgeProps {
    status: SpotStatus;
}

export const SpotStatusBadge = ({ status }: SpotStatusBadgeProps) => (
    <StatusBadge
        value={status}
        colorMap={SPOT_STATUS_COLOR_MAP}
        displayMap={new Map([[status, formatSpotStatus(status)]])}
    />
);
